import { z } from "zod";

export enum CommunityStatus {
  pending = "pending",
  active = "active",
  launched = "launched",
  archived = "archived",
}

export const communityStatusEnum = z.enum(CommunityStatus);
